// extracted by mini-css-extract-plugin
export default {"PasswordInputs":"styles_PasswordInputs__K-GtS","inputContainer":"styles_inputContainer__hHvI5","input":"styles_input__t426E","changePassword":"styles_changePassword__+Y-Zi"};